/**
 * @description: 分销
 * @author: Jsj
 * @Compile：2021-03-29 21：00
 * @update: Jsj(2021-03-23 18：00)
 * @memo：
 */

export default [
  {
    path: "/distributionGoods",
    component: () => import("../pages/distribution/distributionGoods/distributionGoods.vue"),
    name: "distributionGoods",
    title: "分销商品",
    meta: {
      title: "分销商品"
    }
  },
  {
    path: "/promotionalTools",
    component: () => import("../pages/distribution/promotionalTools/promotionalTools.vue"),
    name: "promotionalTools",
    title: "推广工具",
    meta: {
      title: "推广工具"
    }
  },
  {
    path: "/distributors",
    component: () => import("../pages/distribution/distributors/distributors.vue"),
    name: "distributors",
    title: "分销人员",
    meta: {
      title: "分销人员"
    }
  },
  {
    path: "/performance",
    component: () => import("../pages/distribution/performance/performance.vue"),
    name: "performance",
    title: "业绩绩效",
    meta: {
      title: "业绩绩效"
    }
  },
];
